import { getUriForResource } from "../registrar/registrarHelpers";
export class WidgetModelRegistration {
    constructor(widgetRegistration) {
        this.id = widgetRegistration.id;
        this.appId = widgetRegistration.appId;
        this.providerId = widgetRegistration.providerId;
        this.isPlatformWidget = widgetRegistration.entryPoint.type === "PLATFORM";
        this.icon = getUriForResource(widgetRegistration.id, widgetRegistration.icon.src);
        this.title = widgetRegistration.displayName;
        this.maxInstances = widgetRegistration.maxInstances;
        this.supportedAuth = widgetRegistration.supportedAuth;
        this.supportedSizes = widgetRegistration.supportedSizes;
        this.preferredSize = widgetRegistration.preferredSize;
    }
}
